import Box from 'carbon-react/esm/components/box';
import Button from 'carbon-react/esm/components/button/__next__';
import Dialog from 'carbon-react/esm/components/dialog';
import Typography from 'carbon-react/esm/components/typography';

interface RegistrationSuccessDialogProps {
  isAdmin: boolean;
  isOpen: boolean;
  onClose: () => void;
}

const RegistrationSuccessDialog = ({
  isAdmin,
  isOpen,
  onClose,
}: RegistrationSuccessDialogProps) => (
  <Dialog open={isOpen} onCancel={onClose} title="Félicitations">
    <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
      <Typography variant="p" textAlign="center">
        Félicitations, vous pouvez dès à présent utiliser vos services déclaratifs avec votre Sage
        ID.
      </Typography>

      {isAdmin && (
        <Typography variant="p" textAlign="center">
          Vous êtes administrateur. Vous pouvez gérer vos utilisateurs depuis le portail Sage Edi
          Online.
        </Typography>
      )}

      <Typography variant="p" textAlign="center">
        Attention, votre connexion au service doit être renouvelée au moins une fois par mois.
        <br />
        Veillez donc à conserver votre mot de passe Sage ID.
      </Typography>

      <Button onClick={onClose} variantType="primary" size="small">
        Fermer
      </Button>
    </Box>
  </Dialog>
);

export default RegistrationSuccessDialog;
